import { render, staticRenderFns } from "./IconScreenshot.vue?vue&type=template&id=9c2f6b68"
import script from "./IconScreenshot.vue?vue&type=script&lang=js"
export * from "./IconScreenshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports